<mat-accordion
  id="annotations-list-content"
  data-automation-id="annotations-list-accordion"
  multi
  hideToggle
  [displayMode]="'flat'"
>
  @for (chapter of annotations() | filterByState:filterState; track chapter.spineId) {
    @let isExpanded = isSpineExpanded(chapter.spineId);
    <mat-expansion-panel
      class="mat-annotations-list-panel"
      #expPanel
      [id]="chapter.spineId"
      [expanded]="isExpanded"
      (afterExpand)="handleExpand(chapter.spineId)"
      (opened)="handleExpandSpineId(true, chapter.spineId)"
      (closed)="handleExpandSpineId(false, chapter.spineId)"
    >
      <mat-expansion-panel-header
        class="mat-annotations-list-header"
        data-automation-id="annotations-list-chapter-header"
        [attr.aria-expanded]="isExpanded"
        [attr.aria-controls]="'region-' + chapter.spineId"
        [id]="'trigger-' + chapter.spineId"
      >
        <div class="header-content">
          @if (isEditMode) {
            <mat-checkbox
              [attr.data-automation-id]="'annotation-list-chapter-checkbox-' + chapter.spineId"
              class="checkbox-item"
              [disabled]="chapter?.annotations.length === 0"
              [checked]="chapterAllSelected(chapter)"
              [indeterminate]="chapterPartiallySelected(chapter)"
              (change)="chapterToggleChildren(chapter)"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              aria-label="Select all {{ type }} in {{ chapter.label }}"
            ></mat-checkbox>
          }
          <span
            class="chevron-icon"
            [class.expanded]="isExpanded"
          ></span>

          <span>{{ chapter.label }}</span>
        </div>
      </mat-expansion-panel-header>

      <ul
        class="mat-annotations-list-panel-content"
        data-automation-id="material-annotations-list-content"
        role="region"
        [id]="'region-' + chapter.spineId"
      >
        @for (annotation of chapter.annotations; track annotation.cfi) {
          <li
            [attr.data-automation-id]="'annotation-list-item-' + $index"
            class="mat-annotations-list-panel-content-item"
            (click)="handleAnnotationClicked($event, annotation)"
            (keydown.enter)="handleAnnotationClicked($event, annotation)"
            (keydown.space)="handleAnnotationClicked($event, annotation)"
            tabindex="0"
            role="button"
            [attr.aria-label]="annotation | ariaAnnotation:type"
          >
            @if (isEditMode) {
              <mat-checkbox
                [attr.data-automation-id]="'annotation-list-item-checkbox-' + $index"
                class="checkbox-item"
                [checked]="annotation?.selected"
                (change)="handleSelectAllByResource(annotation)"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
                aria-label="{{
                  type === MaterialAnnotationType.NOTES
                    ? 'Select note checkbox: ' + annotation.note
                    : 'Select highlight checkbox: ' + annotation.text
                }}"
              ></mat-checkbox>
            }
            <div class="icon">
              @if (type === MaterialAnnotationType.HIGHLIGHTS && !annotation.orphan) {
                <rdrx-highlight-icon
                  *ngIf="type === 'highlights'"
                  [color]="annotation.color"
                  [shape]="annotation.shape"
                ></rdrx-highlight-icon>
              } @else if (annotation.orphan) {
                <img
                  id='unlink-icon'
                  src="/assets/icons/reader/unlink.svg"
                  alt="Unlink Icon"
                  width="30px"
                  [mheTooltip]="'context.detached_highlight' | translate"
                  [placement]="'right'"
                />
              }
            </div>

            <div class="list-content">
              <div class="list-content-text">
                @if (annotation?.orphan) {
                  @let orphanHighlightMsg = type === MaterialAnnotationType.HIGHLIGHTS
                    ? 'contents.orphan_highlight_msg'
                    : type === MaterialAnnotationType.NOTES
                    ? 'contents.orphan_notes_msg'
                    : 'contents.orphan_placemark_msg';
                  <p class="orphan-highlight-msg">{{ orphanHighlightMsg | translate }}</p>
                }
                @if (annotation?.updatedAt) {
                  <span class="date">
                    {{ annotation?.updatedAt | date : 'shortDate' }}
                  </span>
                }
                <p
                  rdrxTruncate
                  [isEditMode]="isEditMode"
                  class="annotation-text"
                >
                  {{ type === MaterialAnnotationType.NOTES ? annotation.note : annotation.text | cleanText }}
                </p>
              </div>
            </div>

            <button
              mhe-button
              class="trashcan"
              [disabled]="isEditMode"
              [attr.data-automation-id]="'remove-annotation-' + $index"
              [mheStopPropagation]="['click', 'keydown.Enter', 'keydown.Space']"
              rdrxHideOnEscape
              [mheTooltip]="'shared.delete' | translate"
              [alternateAriaLabel]="
                ('shared.delete' | translate) +
                ' ' +
                (type === MaterialAnnotationType.NOTES
                  ? annotation.note
                  : annotation.text)
              "
              (click)="handleAnnotationDelete($event, annotation)"
              (keydown.enter)="handleAnnotationDelete($event, annotation)"
            >
              <i class="dpg-icon dpg-icon-trash"></i>
            </button>
          </li>
        } @empty {
          <mat-progress-spinner
            data-automation-id="annotations-list-content-spinner"
            class="rdrx-spinner spine-annotations-loading"
            mode="indeterminate"
            [strokeWidth]="2"
            [diameter]="45"
          ></mat-progress-spinner>
        }
      </ul>
    </mat-expansion-panel>
  } @empty {
    <p class="empty-message" data-automation-id="annotations-list-empty-message">{{ emptyMessageKey | translate }}</p>
  }
</mat-accordion>
